import { BackButton, Container, Content } from './styles';
import logo from '../../assets/logo.svg';
import { useNavigate } from 'react-router-dom';
import { BiArrowBack } from 'react-icons/bi';
import { toast } from 'react-toastify';
import { FormEvent, useState } from 'react';
import { apiProd } from '../../services/api';

function DefineNewPassword() {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [passwordVerify, setPasswordVerify] = useState('');
  const navigate = useNavigate();

  async function handleDefineNewPassword(e: FormEvent) {
    e.preventDefault();
    setLoading(true);
    if (password !== passwordVerify) {
      toast.error('As senhas não são iguais', {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
      setLoading(false);
      return;
    }
    const user = localStorage.getItem('user');

    if (user) {
      const { id } = JSON.parse(user);
      const response = await apiProd.patch('reset-password', {
        id: id,
        password: password,
      });
      if (response.status === 200) {
        toast.success('Senha alterada com sucesso!', {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
        localStorage.clear();
        setLoading(false);
      } else {
        setLoading(false);
        toast.error('Falha ao alterar senha', {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
      }

      setTimeout(() => {
        navigate('/');
      }, 2000);
    }
  }
  return (
    <Container>
      <BackButton onClick={() => navigate(-1)}>
        <BiArrowBack size={32} />
        <span>Voltar</span>
      </BackButton>
      <Content
        className="reset"
        initial={{ opacity: 0, x: 100 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        onSubmit={handleDefineNewPassword}
      >
        <img src={logo} alt="Logo gazin" />
        <label htmlFor="password">Digite a nova senha:</label>
        <input
          id="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <label htmlFor="confirm_password">Confirme a nova senha:</label>
        <input
          id="confirm_password"
          type="password"
          value={passwordVerify}
          onChange={(e) => setPasswordVerify(e.target.value)}
        />
        {loading ? (
          <div className="lds-dual-ring" />
        ) : (
          <button type="submit" disabled={loading ? true : false}>
            Salvar
          </button>
        )}
      </Content>
    </Container>
  );
}

export default DefineNewPassword;
